/* Yanash product pages (2026-10-05): live game round in #eich. */
(function () {
  /* Guess round */
  var deck = document.getElementById('pgDeck');
  if (!deck) return;
  var D = {}; try { D = JSON.parse(document.getElementById('pgData').textContent); } catch (e) { return; }
  var cards = [].slice.call(deck.querySelectorAll('.flip')), Q = D.quiz, n = 0, score = 0, g = D.gran || 'סבתא';
  var $ = function (id) { return document.getElementById(id); };
  var opts = $('pgOpts'), fb = $('pgFb'), nw = $('pgNextWrap'), end = $('pgEnd'), qn = $('pgQn'), qs = $('pgQs');
  var L = ['א', 'ב', 'ג'];
  var flip = function (c, on) { c.setAttribute('aria-pressed', on ? 'true' : 'false'); };
  var layout = function () {
    cards.forEach(function (c, i) {
      c.classList.remove('cur', 'n1', 'n2', 'gone');
      c.classList.add(i < n ? 'gone' : i === n ? 'cur' : 'n' + Math.min(i - n, 2));
      c.tabIndex = i === n ? 0 : -1;
    });
  };
  var round = function () {
    layout(); qn.textContent = n + 1; qs.textContent = score;
    fb.hidden = true; nw.hidden = true; opts.innerHTML = '';
    Q[n].opts.forEach(function (t, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pg-opt'; b.dataset.l = L[i]; b.textContent = t;
      b.addEventListener('click', function () { answer(i); }); opts.appendChild(b);
    });
  };
  var answer = function (i) {
    var ok = Q[n].ok;
    [].forEach.call(opts.querySelectorAll('.pg-opt'), function (b, j) { b.disabled = true; b.classList.add(j === ok ? 'ok' : j === i ? 'no' : 'dim'); });
    if (i === ok) score++;
    qs.textContent = score;
    fb.textContent = i === ok ? 'בול. ' + g + ' גאה בכם. בגב הקלף מחכים התכלס ומתי שולפים אותו.' : 'כמעט. ככה בדיוק נשמע ערב עם יאנאש. תראו בגב הקלף מה זה אומר באמת.';
    fb.hidden = false;
    flip(cards[n], true);
    if (n < cards.length - 1) nw.hidden = false;
    else setTimeout(function () { end.hidden = false; }, 700);
  };
  $('pgNext').addEventListener('click', function () { flip(cards[n], false); n++; round(); });
  $('pgAgain').addEventListener('click', function () { cards.forEach(function (c) { flip(c, false); }); n = 0; score = 0; end.hidden = true; round(); });
  round();
})();
